import isObject from "lodash/isObject"
// https://thewebdev.info/2021/03/06/how-to-deep-merge-javascript-objects/
function mergeDeep(target: { [key:string]: any }, ...sources: any): any {
  if (!sources.length)
    return target;

  const source: {[key:string]: any} | undefined = sources.shift();

  if (isObject(target) && isObject(source)) {
    for (const key in source) {
      //@ts-ignore - Internet copy
      if (isObject(source[key])) {
        //@ts-ignore - Internet copy
        if (!target[key]) Object.assign(target, {
          [key]: {}
        });
        //@ts-ignore - Internet copy
        mergeDeep(target[key], source[key]);
      } else {
        // @ts-ignore - Added this myself, but still internet copy
        if (undefined !== source[key]) {
          Object.assign(target, {
            //@ts-ignore - Internet copy
            [key]: source[key]
          });
        }
      }
    }
  }

  return mergeDeep(target, ...sources);
}

export default mergeDeep
